import { apiGET } from './api';

export const getRescuerLocationTypes = () => apiGET('/rescuer_location_types');
